
export default function Footer () {
	return (
		<footer className='flex-2 bg-blue-200'>
			<div className="footer__inner container flex justify-between items-center mx-auto py-4 px-8">
				<div className="footer__left flex items-center">
					<a href="https://vk.com/tenchi_samara" target="_blank" className="footer__logo" rel="noreferrer">
						<img src='/images/logo.png' className="w-16" alt="logo" />
						Школа айкидо &laquo;<span className="whitespace-nowrap">Тэн-Чи</span>&raquo;
					</a>
					{/* <p className="footer__title">Школа айкидо &laquo;<span className="whitespace-nowrap">Тэн-Чи</span>&raquo;</p> */}
				</div>

			</div>
		</footer>
	)
	
}